"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumUtils = void 0;
const errors_1 = require("@invivodf/errors");
class EnumUtils {
    /**
     *
     * @param value "potentiel value of the enum"
     * @param enumType "enum object"
     */
    static deduce(value, enumType) {
        const enumKey = Object.keys(enumType).find((key) => enumType[key] === value);
        if (!enumKey) {
            throw new errors_1.DomainError(`Unknown enum value '${value}' for this enum '${JSON.stringify(enumType)}'`, 'UNKNOWN_ENUM_VALUE');
        }
        return enumType[enumKey];
    }
}
exports.EnumUtils = EnumUtils;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bS51dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9lbnVtLXV0aWxzL2VudW0udXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkNBQThDO0FBRTlDLE1BQWEsU0FBUztJQUNwQjs7OztPQUlHO0lBQ0gsTUFBTSxDQUFDLE1BQU0sQ0FBNEMsS0FBYSxFQUFFLFFBQVc7UUFDakYsTUFBTSxPQUFPLEdBQXlCLE1BQU0sQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFvQixDQUFDLElBQUksQ0FDakYsQ0FBQyxHQUFZLEVBQUUsRUFBRSxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUMsS0FBSyxLQUFLLENBQzFDLENBQUE7UUFFRCxJQUFJLENBQUMsT0FBTyxFQUFFLENBQUM7WUFDYixNQUFNLElBQUksb0JBQVcsQ0FDbkIsdUJBQXVCLEtBQUssb0JBQW9CLElBQUksQ0FBQyxTQUFTLENBQUMsUUFBUSxDQUFDLEdBQUcsRUFDM0Usb0JBQW9CLENBQ3JCLENBQUE7UUFDSCxDQUFDO1FBRUQsT0FBTyxRQUFRLENBQUMsT0FBTyxDQUFDLENBQUE7SUFDMUIsQ0FBQztDQUNGO0FBcEJELDhCQW9CQyJ9